import api from '@/lib/api';
import type { PaginatedResponse } from '@pms/shared';

export interface AuditLogEntry {
  id: string;
  actorId: string | null;
  actorEmail: string | null;
  action: string;
  entityType: string;
  entityId: string;
  entityName: string | null;
  changes: Record<string, { old: unknown; new: unknown }> | null;
  ipAddress: string | null;
  createdAt: string;
}

export interface AuditLogsQuery {
  page?: number;
  limit?: number;
  entityType?: string;
  action?: string;
  from?: string;
  to?: string;
}

export async function fetchAuditLogs(query: AuditLogsQuery): Promise<PaginatedResponse<AuditLogEntry>> {
  const { data } = await api.get<PaginatedResponse<AuditLogEntry>>('/audit-logs', { params: query });
  return data;
}
